import React from 'react';
import { circleColor, IconProps, strokeColor } from './icons.utils';

export const TeamsIcon: React.FC<IconProps> = ({
  active,
  className = '',
  disabled = false,
}: IconProps): JSX.Element => {
  const stroke = disabled ? '#b8b8b8' : strokeColor(active);

  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="12" cy="12.2549" r="12" fill={circleColor(active)} />
      <path
        d="M14 15.2879C14 13.9993 15.0447 12.9546 16.3333 12.9546H19.6666C20.9553 12.9546 22 13.9993 22 15.2879C22 15.472 21.8507 15.6212 21.6666 15.6212H14.3333C14.1492 15.6212 14 15.472 14 15.2879Z"
        stroke={stroke}
        strokeWidth="2"
      />
      <circle
        cx="18"
        cy="8.95478"
        r="1.69989"
        stroke={stroke}
        strokeWidth="2"
      />
      <path
        d="M2 15.2879C2 13.9993 3.04466 12.9546 4.33332 12.9546H7.66665C8.95531 12.9546 9.99997 13.9993 9.99997 15.2879C9.99997 15.472 9.85074 15.6212 9.66664 15.6212H2.33333C2.14924 15.6212 2 15.472 2 15.2879Z"
        stroke={stroke}
        strokeWidth="2"
      />
      <circle
        cx="5.99995"
        cy="8.95478"
        r="1.69989"
        stroke={stroke}
        strokeWidth="2"
      />
      <path
        d="M8 17.0521C8 15.7634 9.04466 14.7188 10.3333 14.7188H13.6666C14.9553 14.7188 16 15.7634 16 17.0521C16 17.2362 15.8507 17.3854 15.6666 17.3854H8.33333C8.14924 17.3854 8 17.2362 8 17.0521Z"
        fill={stroke}
        stroke={stroke}
        strokeWidth="2"
      />
      <circle
        cx="12"
        cy="10.7189"
        r="1.69989"
        stroke={stroke}
        strokeWidth="2"
      />
    </svg>
  );
};
